/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Sync_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "Sync keeps failing, what should I check?" |
*
* @param {Uno_Edu_Space_Sync_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_sync_chip2_label = /** @type {((inputs?: Uno_Edu_Space_Sync_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Sync_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Synchronisierung schlägt fehl, was soll ich prüfen?")
	return /** @type {LocalizedString} */ ("Sync keeps failing, what should I check?")
});